import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { AppFile, AssetsService, FileService, IAsset } from 'taxtank-core';

/**
 * Directive to download assets
 */
@Directive({
  selector: '[appDownload]',
  standalone: false
})
export class DownloadDirective {
  // @TODO remove IAsset after refactoring
  @Input('appDownload') asset: IAsset | AppFile;

  private assetsService = inject(AssetsService);
  private fileService = inject(FileService);
  private el = inject(ElementRef);

  @HostListener('click') onClick(): void {
    if (this.asset instanceof AppFile) {
      this.el.nativeElement.disabled = true;
      this.fileService.download(this.asset).subscribe((blob: Blob) => this.download(blob));
    } else {
      window.open(this.assetsService.download(this.asset), '_self');
    }
  }

  private download(blob: Blob) {
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = this.asset.originalName;
    downloadLink.dispatchEvent(new MouseEvent('click'));
    this.el.nativeElement.disabled = false;
  }
}
